<template>
  <div class="base-model__content scrollable destination-modal">
    <button
      role="button"
      aria-label="Dismiss modal"
      class="button--text button--icon close-button"
      @click="
        () => {
          closeModal();
        }
      "
    >
      <i class="icon icon-close-filled icon--lg" aria-hidden="true"></i>
    </button>

    <div class="modal-content__header">
      <div class="destination-bg-container">
        <picture class="destination-bg-image">
          <source
            :srcset="destinationData?.images?.['Extra Extra Large']"
            media="(min-width:1400px)"
          />
          <source
            :srcset="destinationData?.images?.['Large']"
            media="(min-width:1199px)"
          />
          <source
            :srcset="destinationData?.images?.['Extra Small']"
            media="(min-width:575px)"
          />
          <img
            :src="destinationData?.images?.['Extra Small']"
            alt="destination image"
          />
        </picture>
      </div>
      <section class="destination-modal__destination-info">
        <div class="destination-code-row text-white">
          <span class="destination-chip text-KQ-White">{{
            destinationData.fromDestinationCode
          }}</span>
          <i
            class="icon icon-airplane-right icon--xxs icon-color--white"
            aria-hidden="true"
          ></i>
          <span class="destination-chip text-KQ-White">{{
            destinationData.toDestinationCode
          }}</span>
        </div>
        <p class="heading-h5 text-KQ-White">
          {{ destinationData.fromDestination }} to
          {{ destinationData.toDestination }}
        </p>
        <p class="text-KQ-White">
          {{ destinationData.tripType }} in {{ destinationData.tripClass }}
        </p>
        <p class="text-KQ-White text--bold">
          From {{ destinationData.tripCost }}
        </p>
      </section>
    </div>

    <section class="destination-modal__booking-block">
      <div class="destination-modal__booking-block-info text-KQ-White">
        <div class="destination-travel-info text-KQ-White">
          <span class="destination-travel-info__label">Travel Dates</span
          >{{ destinationData.travelDates }}
        </div>
        <div class="destination-travel-info text-KQ-White">
          <span class="destination-travel-info__label">Trip Duration</span
          >{{ destinationData.tripDuration }}
        </div>
        <div class="destination-travel-info text-KQ-White">
          <span class="destination-travel-info__label">Promo Fare</span
          >{{ destinationData.farePromotionDuration }}
        </div>
      </div>
      <div class="destination-modal__booking-block-placeholder">
        Booking widget placeholder
      </div>
      <slot name="visahealthtrigger"></slot>
    </section>

    <div class="modal-content__content">
      <slot></slot>
    </div>
  </div>
</template>
<script setup>
import { provide, ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  destinationData: {
    type: Object,
    default: () => {
      return {
        dealId: '01',
        fromDestinationCode: 'NBO',
        toDestinationCode: 'MBU',
        fromDestination: 'Nairobi',
        toDestination: 'Mauritius',
        tripType: 'Return',
        tripClass: 'Economy Class',
        tripCost: 'KES 99,999',
        travelDates: '00 Mon 22 to 00 Mon 22',
        tripDuration: 'From 3 days to 3 months',
        farePromotionDuration: 'Until 00 Mon 22',
        images: {},
      };
    },
  },
});

const emit = defineEmits(['close:modal']);

function closeModal() {
  emit('close:modal', false);
}

</script>
